import { Component } from '@poa/core';
import { observable } from '@poa/state';
import React from 'react';
import classNames from 'classnames';
import GeneralInfoProfile from './components/general-info';
import GeneralFinanceProfile from './components/general-finance';
import GeneralTransferProfile from './components/general-transfers';
import GeneralDialogsList from './components/general-dialogs';
import GeneralAiReport from './components/general-ai';

class GeneralInfo extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa

    localState = observable({
        activeTabIndex: 0,
        searchValue: ''
    });

    setActiveTabIndex = (index) => {
        this.localState.activeTabIndex = index;
    }

    onSearchChange = (event) => {
        this.localState.searchValue = event.target.value;
    }

    onSearchClick = async () => {
        await this.actions.generalProfileActions.fetchGeneralProfile(this.localState.searchValue); 
    }

    render() {

        const generalTabIsActiveClass = classNames('general_menu', {
            'general_menu--active': this.localState.activeTabIndex === 0
        });

        const financeTabIsActiveClass = classNames('general_menu', {
            'general_menu--active': this.localState.activeTabIndex === 1
        });

        const operatorTabIsActiveClass = classNames('general_menu', {
            'general_menu--active': this.localState.activeTabIndex === 2
        });

        const dialogsTabIsActiveClass = classNames('general_menu', {
            'general_menu--active': this.localState.activeTabIndex === 3
        });

        const aiTabIsActiveClass = classNames('general_menu', {
            'general_menu--active': this.localState.activeTabIndex === 4
        });

        const tabs_indexes = {
            0: generalTabIsActiveClass,
            1: financeTabIsActiveClass,
            2: operatorTabIsActiveClass,
            3: dialogsTabIsActiveClass,
            4: aiTabIsActiveClass,
        }

        const tabsData = {
            0: <GeneralInfoProfile />,
            1: <GeneralFinanceProfile />,
            2: <GeneralTransferProfile />,
            3: <GeneralDialogsList />,
            4: <GeneralAiReport />,
        }

        const tabsNames = [
            "General",
            "Finance",
            "Operators",
            "Dialogs",
            "AI"
        ]

        return (
            <div className='general-page__container-info'>
                <div className="general_info__header">
                    <ul className='menu' style={{ width: "75%" }}>
                        {tabsNames.map((tab, idx) => {
                            return (
                                <li key={idx}>
                                    <p
                                        onClick={() => this.setActiveTabIndex(idx)}
                                        className={tabs_indexes[idx]}>
                                        {tab}
                                    </p>
                                </li>
                            );
                        })}
                    </ul>
                    <div className='general_sidebar-header__search' style={{ minWidth: "200px", maxWidth: '200px' }}>
                        <div className='search__input input'>
                            <input
                                type='text'
                                placeholder='search client'
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        this.onSearchClick();
                                    }
                                }}
                                onChange={this.onSearchChange}>
                            </input>
                            <svg className='icon icon-search' onClick={this.onSearchClick} width='15px' height='15px' viewBox='0 0 15 15'
                                version='1.1' xmlns='http://www.w3.org/2000/svg'>
                                <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                                    <g fillRule='nonzero' fill='#DBDBDB'>
                                        <path
                                            d='M14.8163265,13.9346939 L11.2102041,10.3285714 C12.1040816,9.23877551 12.6428571,7.84285714 12.6428571,6.32142857 C12.6428571,2.83163265 9.81122449,0 6.32142857,0 C2.82857143,0 0,2.83163265 0,6.32142857 C0,9.81122449 2.82857143,12.6428571 6.32142857,12.6428571 C7.84285714,12.6428571 9.23571429,12.1071429 10.3255102,11.2132653 L13.9316327,14.8163265 C14.1765306,15.0612245 14.5714286,15.0612245 14.8163265,14.8163265 C15.0612245,14.5744898 15.0612245,14.1765306 14.8163265,13.9346939 Z M6.32142857,11.3846939 C3.52653061,11.3846939 1.25510204,9.11326531 1.25510204,6.32142857 C1.25510204,3.52959184 3.52653061,1.25510204 6.32142857,1.25510204 C9.11326531,1.25510204 11.3877551,3.52959184 11.3877551,6.32142857 C11.3877551,9.11326531 9.11326531,11.3846939 6.32142857,11.3846939 Z'></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
                {tabsData[this.localState.activeTabIndex]}
            </div>
        );
    }
}

export default Component({ namespaces: ['general-info'] })(GeneralInfo);